import React, { useState, useEffect } from 'react'
import { FaUser, FaInfoCircle, FaSave } from 'react-icons/fa';
import { Spin, notification, DatePicker } from 'antd'
import dayjs from 'dayjs';
import moment from 'moment';
import axios from 'axios';
import { LoadingOutlined } from '@ant-design/icons';
export default function CpnDongHD({ loanId }) {
  const [closeDate, setCloseDate] = useState('01/01/1999');
  const [amount, setAmount] = useState('');
  const [loadingItem, setLoadingItem] = useState(false); // Track loading state for each row
  

  const whiteSpinnerIcon = <LoadingOutlined style={{ fontSize: 24, color: 'white' }} spin />;

  useEffect(() => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0'); // Lấy ngày và thêm số 0 nếu cần
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Lấy tháng (0-11) và thêm số 0
    const year = today.getFullYear(); // Lấy năm

    const formattedDate = `${day}/${month}/${year}`;
    setCloseDate(formattedDate); // Lưu vào state
  }, []); // Chỉ chạy một lần khi component được mount

  const [totalNeedPay, setTotalNeedPay] = useState(0);
  const [debitMoney, setDebitMoney] = useState('');
  const [totalMoneyNeedClose, setTotalMoneyNeedClose] = useState(0)
  useEffect(() => {
    const token = localStorage.getItem('token'); // Thay 'your_token_key' bằng key thực tế
    fetch(`${process.env.REACT_APP_API_DB_URL}/loan-credit/${loanId}`,
      {
        method: 'GET', // Hoặc 'POST' nếu cần thiết
        headers: {
          'Authorization': `Bearer ${token}`, // Thêm token vào headers
          'Content-Type': 'application/json' // Nếu cần
        }
      })
      .then(response => response.json())
      .then(data => {
      //  console.log(data)
        setTotalNeedPay(data.TOTAL_MONEY_NEED_PAY);
        setDebitMoney(data.DEBIT_MONEY);
        setTotalMoneyNeedClose(data.TOTAL_MONEY_NEED_PAY + data.DEBIT_MONEY);
      //  console.log(data.TOTAL_MONEY_NEED_PAY + data.DEBIT_MONEY)
      })
      .catch(error => console.error('Error fetching data:', error))
  }, []);


  const showNotification = (message, type) => {
    notification[type]({
      description: message,
      placement: 'topRight', // Notification position
    });
  };

  const handleSubmit = async () => {
    const payload = {
    };
    try {
      setLoadingItem(true);
      const token = localStorage.getItem('token'); // Lấy token từ localStorage
      const response = await axios.post(
        `${process.env.REACT_APP_API_DB_URL}/close-loan-installment/${loanId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}` // Thêm token vào header
          }
        }
      );

      let message = '';
      let type = '';
      if (response.status === 200) {
        message = `Đóng HĐ thành công, mã HĐ: ${loanId}` 
        type = 'success';
      } else {
        message = 'Đóng HĐ thất bại';
        type = 'error';
      }

      showNotification(message, type);
   //   console.log('Response:', response.data);
    } catch (error) {
      console.error('Error saving contract:', error);
    } finally {
      setLoadingItem(false);
    }
  };

  return (
    <div className="p-8">
      <div className="flex flex-col">
        <div className="mb-4 flex items-start w-full max-w-xs">
          <label className="block text-gray-700 text-sm font-bold mr-4 flex-shrink-0 w-1/2" htmlFor="date">
            Số kỳ còn phải đóng
          </label>
          <div className="flex items-center">
            <label>{totalNeedPay.toLocaleString('vi-VN')} VNĐ
            </label>
          </div>
        </div>

        <div className="mb-4 flex items-start w-full max-w-xs">
          <label className="block text-gray-700 text-sm font-bold mr-4 flex-shrink-0 w-1/2" htmlFor="date">
            Nợ cũ
          </label>
          <div className="flex items-center">
            <label>{debitMoney.toLocaleString('vi-VN')} VNĐ
            </label>
          </div>
        </div>

        <div className="mb-4 flex items-start w-full max-w-xs">
          <label className="block text-gray-700 text-sm font-bold mr-4 flex-shrink-0 w-1/2" htmlFor="date">
            Tổng tiền cần đóng
          </label>
          <div className="flex items-center">
            <label>{totalMoneyNeedClose.toLocaleString('vi-VN')} VNĐ
            </label>
          </div>
        </div>

        <div className="mb-4 flex items-start w-full max-w-xs">
          <div className="block text-gray-700 text-sm font-bold mr-4 flex-shrink-0 w-1/2" htmlFor="amount" />

          <div className="flex flex-col items-center mt-4">
            <button
              className="bg-blue-500 text-white px-4 py-2 rounded flex items-center justify-center relative"
              onClick={handleSubmit}
            >
              <FaSave className="mr-2" />
              <span>Đóng HĐ</span>
              {loadingItem && ( // Show Spin only when loading
                <span className="ml-3">
                  <Spin indicator={whiteSpinnerIcon} />
                </span>
              )}
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}
